//- 控制开关,dev、test、prod
var ENV = process.env.VUE_APP_ENV;

import { ORDERAPI } from "./orderApi";
import SUPPLIER from "./supplier";
import SERVICE from "./service";
import BASEDATA from "./baseData";
import H5API from "./h5api";
import EVAAPI from "./evaapi";

//- 环境变量
var pathUrl = function () {
  var URLS = {
    dev: {
      domain: "https://ccapidev.miaohealth.net",
      hDomain: "https://health-standard.miao.cn",
      cDomain: "https://apitest.miaocloud.net/",
    },
    test: {
      domain: "http://localhost:31000", // 测试服务器
      hDomain: "https://healthapitest.miaohealth.net",
      cDomain: "https://apitest.miaocloud.net/",
    },
    prod: {
      domain: "/api",
      hDomain: "/oldapi",
      cDomain: "/cloudapi",
      eDomain: "/evaluation",
    },
    local: {
      // 本地开发走 dev 代理：/api -> localhost:31000（见 vue.config.js）
      domain: "/api",
      hDomain: "/oldapi",
      cDomain: "/cloudapi",
      eDomain: "/evaluation",
    },
  };
  if (process.env.NODE_ENV === "development") {
    return URLS["local"];
  } else {
    return URLS[ENV];
  }
};

//- 接口
let apiCore = {
  qaDetail: "/cms/wenjuan/view", //答题记录
  qaAll: "/cms/wenjuan/show", //问卷预览
  crmCustomerInsuredNUmber: "/cms/gw/crm/customer/insuredNumber", // 首页-核保数据
  cmsUserStatics: "/cms/user/statics", // 首页-核保数据
  adminMessage: "/cms/admin/message", // 首页-待办消息
  messageViewed: "/cms/admin/message/viewed", // 首页-待办消息忽略

  cmsOrderStatics: "/cms/order/statics", // 首页-服务数据
  cmsproviderByServiceId: "/cms/provider/viewByServiceId", // 首页-tip byid

  statisticsData: "/cms/healthData/statistics", // 首页-健康数据
  controllable: "/cms/riskFactor/controllable", //健康档案列表可控风险
  ...H5API,
  ...ORDERAPI,
  ...SUPPLIER,
  ...SERVICE,
  ...BASEDATA,
  ...EVAAPI,
  areaTopList: "/cms/area/top/list", // 省级地址列表
  areaList: "/cms/area/list", // 下级地址列表

  oaAuth: "/cms/admin/oaAuth", // oA系统登录对接校验
  adminLogin: "/cms/admin/login", // 登录接口
  logout: "/cms/admin/logout", // 登出接口
  loginCheck: "/cms/admin/check", // 登录校验
  updatePwd: "/cms/admin/update-pwd", // 修改密码
  adminIndex: "/cms/admin/index", // 分页查询系统管理员
  adminSave: "/cms/admin/save", // 新增系统管理员
  orgList: "/cms/admin/internal/org", // 机构列表
  adminResetPwd: "/cms/admin/reset-pwd", // 重置密码
  userAllotList: "/cms/role/user/allot/list", // 管理员分配角色查询
  roleUserAllot: "/cms/role/user/allot", // 管理员分配角色
  adminShelf: "/cms/admin/shelf", // 用户禁用、启用
  adminView: "/cms/admin/view", // 查询详情
  getRoleList: "/cms/role/index", // 分页查询角色
  getLogPage: "/cms/sys/log/page", // 操作日志
  roleSave: "/cms/role/save", // 保存角色
  roleView: "/cms/role/view", // 查看角色详情
  roleShelf: "/cms/role/shelf", // 禁用、启用角色
  allotList: "/cms/permission/allot/list", // 角色授权列表查询
  permissionAllot: "/cms/permission/allot", // 角色绑定权限
  operateLogIndex: "/cms/operate/log/index", // 查询系统日志

  getAreaList: "/cms/area/search", // 行政区域列表
  areaAdd: "/cms/area/create", // 行政区域添加
  areaUpdate: "/cms/area/update", // 行政区域修改
  areaProvince: "/cms/area/top/list", // 省列表
  areaCity: "/cms/area/city/list", // 市列表
  areaExist: "/cms/area/exist", // 判断地区是否存在
  areaWebsiteExist: "/cms/area/exist/hospital", // 判断地区是否存在关联网点
  areaDelete: "/cms/area/delete", // 删除区/县
  areaExport: "/cms/area/export", // 导出行政区

  cmsRightPage: "/cms/right/page", // 用户权益 分页查询
  cmsRightExport: "/cms/right/export", // 用户权益导出
  cmsRightOptions: "/cms/right/option", // 用户权益列表

  superviseReport: "/cms/superviseReport/page", // 监管报表分页查询
  superviseReportExport: "/cms/superviseReport/export", // 监管报表导出
  customerReport: "/cms/gw/crm/page", // 客户量报表分页查询

  financeQuery: "/cms/finance/query", // 财务报表分页查询

  financeExport: "/cms/finance/export", // 财务报表导出

  // 六项服务订单
  // 专家预约
  appointmentOrderHistoricalTrack:
    "/cms/expert/appointment/order/historicalTrack", // 专家预约历史轨迹
  appointmentOrderPage: "/cms/expert/appointment/order/page", // 专家预约分页查询
  appointmentOrderInfo: "/cms/expert/appointment/order/info", // 专家预约订单详情
  appointmentOrderExport: "/cms/expert/appointment/order/export", // 专家预约订单导出
  appointmentOrderItemList: "/cms/expert/appointment/order/item/list", // 专家预约服务项目列表
  appointmentOrderProviderList: "/cms/expert/appointment/order/provider/list", // 专家预约供应商列表
  // 专家手术
  surgeryOrderPage: "/cms/expert/surgery/order/page", // 专家手术分页查询
  surgeryOrderInfo: "/cms/expert/surgery/order/info", // 专家手术订单详情
  surgeryOrderHistoricalTrack: "/cms/expert/surgery/order/historicalTrack", // 专家手术历史轨迹
  surgeryOrderExport: "/cms/expert/surgery/order/export", // 专家手术订单导出
  surgeryOrderItemList: "/cms/expert/surgery/order/item/list", // 专家手术服务项目列表
  surgeryOrderProviderList: "/cms/expert/surgery/order/provider/list", // 专家手术供应商列表
  // 专家病房
  wardOrderPage: "/cms/expert/ward/order/page", // 专家病房分页查询
  wardOrderHistoricalTrack: "/cms/expert/ward/order/historicalTrack", // 专家病房历史轨迹
  wardOrderExport: "/cms/expert/ward/order/export", // 专家病房订单导出
  wardOrderInfo: "/cms/expert/ward/order/info", // 专家病房订单详情
  wardOrderItemList: "/cms/expert/ward/order/item/list", // 专家病房服务项目列表
  wardOrderProviderList: "/cms/expert/ward/order/provider/list", // 专家病房供应商列表
  // 健康体检
  evaCountList: "/cms/wenjuan/getList", // 新增菜单健康评估记录列表查询
  getCountData: "/cms/wenjuan/getCount", // 健康评估记录统计数据
  medicalOrderPage: "/cms/medical/order/page", // 健康体检分页查询
  medicalOrderHistoricalTrack: "/cms/medical/order/historicalTrack", // 健康体检历史轨迹
  medicalOrderExport: "/cms/medical/order/export", // 健康体检订单导出
  medicalOrderItemList: "/cms/medical/order/item/list", // 健康体检服务项目列表
  medicalOrderProviderList: "/cms/medical/order/provider/list", // 健康体检供应商列表
  // 电话医生
  callDoctorOrderPage: "/cms/call/doctor/order/page", // 电话医生分页查询
  callDoctorOrderInfo: "/cms/call/doctor/order/info", // 电话医生订单详情
  callDoctorOrderExport: "/cms/call/doctor/order/export", // 电话医生订单导出
  callDoctorOrderItemList: "/cms/call/doctor/order/item/list", // 电话医生服务项目列表
  callDoctorOrderProviderList: "/cms/call/doctor/order/provider/list", // 电话医生供应商列表
  // 视频医生
  videoDoctorOrderPage: "/cms/video/doctor/order/page", // 视频医生分页查询
  videoDoctorOrderInfo: "/cms/video/doctor/order/info", // 视频医生订单详情
  videoDoctorOrderExport: "/cms/video/doctor/order/export", // 视频医生订单导出
  videoDoctorOrderItemList: "/cms/video/doctor/order/item/list", // 视频医生服务项目列表
  videoDoctorOrderProviderList: "/cms/video/doctor/order/provider/list", // 视频医生供应商列表
};
// 获取apiCode的url
let getApiUrl = function (apiName, domain) {
  if (apiCore[apiName]) {
    let _domain = domain ? domain : "domain";
    return pathUrl()[_domain] + apiCore[apiName];
  } else {
    return "";
  }
};
let getApiUrlE = function (apiName) {
  if (apiCore[apiName]) {
    return "/evaluation" + apiCore[apiName];
  } else {
    return "";
  }
};
//- export
export default {
  ENV,
  pathUrl,
  apiCore,
  getApiUrl,
  getApiUrlE,
};
